
export const containsErrors = errors => {
    const keys = Object.keys(errors)
    for (let key of keys) {
        let arr = errors[key];
        if (arr.length > 0) return true
    }
    return false;
}